import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.generateEmailState || initialState;

export const selectInventory = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.inventory,
);

export const selectCompiledTemplate = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.compileTemplate,
);

export const selectUploadFile = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.uploadFile,
);

export const selectTemplates = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.templates,
);

export const selectCategories = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.categories,
);

export const selectSubCategories = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.subCategories,
);

export const selectSegments = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.segments,
);

export const selectAlgorithm = createSelector(
  [selectDomain],
  generateEmailState => generateEmailState.algorithm,
);


